import config from "./config";
function truncateText(text, maxLength) {
  if (text?.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
}

function formatPrice(price) {
  const formattedPrice = Number(price);
  if (isNaN(formattedPrice)) {
    return 0;
  }
  const myPrice = formattedPrice < 0 ? formattedPrice * -1 : formattedPrice;
  if (Number.isInteger(myPrice)) {
    return myPrice.toLocaleString();
  } else {
    return parseFloat(myPrice.toFixed(2)).toLocaleString();
  }
}

function getImageUrl(imageUrl, height = null, width = null) {
  if (imageUrl?.startsWith("http")) {
    return imageUrl;
  }

  const imageResize = imageUrl?.replace("images", "imageResize");
  let url = `${config.baseURL}${imageResize}`;
  
  if (height || width) {
    const params = [];
    if (height) params.push(`height=${height}`);
    if (width) params.push(`width=${width}`);
    url += `?${params.join('&')}`;
  }
  
  return url;
}

export {
  truncateText,
  formatPrice,
  getImageUrl,
};
